// polyfill for old browsers (es6, promises etc)
// import "core-js";
import objectFitImages from 'object-fit-images'; // object-fit polyfill
import 'whatwg-fetch'; // fetch
import { initAppboy } from './account/apis/Appboy';

// initAppboy();

// Load Modules
import './modules/nav';
// import "./modules/footer"; // removed due to not needing sticky/cookie functionality anymore
import './modules/scrolling';
import './modules/carousel';
import './modules/lightbox';
import './modules/accordion';
import './modules/modal';
import './modules/underline';
import './modules/app-links';
import './modules/competition-form';
import './modules/smoothscroll.js';
import './modules/anchorscroll.js';
// import './modules/slider';
import './modules/react-slider';
import './modules/playpausevideo';

// Load Page scripts/functions
// import './account'; // entry point for account management app
import './pages/menu-listing';
import './pages/store-finder';
import './pages/store-detail';

// Global page scripts/functions
import './pages/global';

// Import online ordering scripts (logged in state and users active orders component)
import './modules/online-ordering-script-loader';

// Init object-fit polyfill
objectFitImages();
